export interface Parameter {
  id: number;
  key: string;
  value: string;
  required: boolean;
}

export interface Header {
  id: number;
  key: string;
  value: string;
  required: boolean;
}

export const useParameterManager = () => {
  const addParameter = (parameters: Parameter[], type: string) => {
    const newId = parameters.length;
    return [
      ...parameters,
      {
        id: newId,
        key: '',
        value: '',
        required: false,
      },
    ];
  };

  const addHeader = (headers: Header[]) => {
    const newId = headers.length;
    return [
      ...headers,
      {
        id: newId,
        key: '',
        value: '',
        required: false,
      },
    ];
  };

  const updateParameter = (
    parameters: Parameter[],
    id: number,
    field: keyof Parameter,
    value: string | boolean,
  ) => {
    return parameters.map((param) => (param.id === id ? { ...param, [field]: value } : param));
  };

  const updateHeader = (
    headers: Header[],
    id: number,
    field: keyof Header,
    value: string | boolean,
  ) => {
    return headers.map((header) => (header.id === id ? { ...header, [field]: value } : header));
  };

  const removeParameter = (parameters: Parameter[], id: number) => {
    return parameters.filter((param) => param.id !== id);
  };

  const removeHeader = (headers: Header[], id: number) => {
    return headers.filter((header) => header.id !== id);
  };

  return {
    addParameter,
    addHeader,
    updateParameter,
    updateHeader,
    removeParameter,
    removeHeader,
  };
};
